import { API_URL } from '../../../utils/config';
import { handleError } from '../common-message/message-action';
import { makeApiCall } from '../common/common-action';

export function getMyInfoRedirectUrl(isRfiFlow = false, rfiId = null) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/myinfo`,
        withCredentials: true
      });
      if (response && response.data && response.data.data) {
        // If its an RFI SINGPASS flow - set LS to work with callback url once redirected back
        if (isRfiFlow) localStorage.setItem('SINGPASS_RFI_FLOW', rfiId);
        window.location = response.data.data.myinfo_redirect_url;
      }
    } catch (error) {
      dispatch(handleError(error));
      return error.response;
    }
  };
}

export function getMyInfoPersonalData(code, state, url, isRfi = false) {
  return async (dispatch) => {
    try {
      let response = await makeApiCall({
        method: 'post',
        url: `${API_URL}/myinfo/person-data`,
        withCredentials: true,
        data: {
          code,
          state
        }
      });
      if (response?.data?.success && response.data.data?.success && !isRfi) {
        window.location = window.location.origin + url;
      }
      return response;
    } catch (error) {
      dispatch(handleError(error));
      return error.response;
    }
  };
}
